import React, { useState, useEffect } from 'react'
import { Alert, Button, Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import ConfigLayout from '../../Layouts/ConfigLayout'
import { useFormik } from 'formik'
import { ValidateCodeSchema } from '../../../utils/validation'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { resendCode, validateUser } from '../../../redux/actions/user'

const Validate = () => {
  const [alertState, setAlertState] = useState({
    show: true,
    variant: 'info',
    message: 'Please check your email for a validation code'
  })

  const history = useHistory()

  const dispatch = useDispatch()

  const { user, validateUserState } = useSelector((state) => ({
    user: state.user.user,
    validateUserState: state.user.validateUser
  }))

  useEffect(() => {
    if (validateUserState.success) {
      if (user.role.roleId === 1) {
        history.push('/configurator')
      } else {
        history.push(`/health-system/${user.healthSystem.tenant}`)
      }
    }

    if (validateUserState.error !== false) {
      setAlertState({
        show: true,
        variant: 'danger',
        message: validateUserState.error.message
      })
    }
  }, [validateUserState.success, validateUserState.error])

  const resendCodeState = useSelector((state) => state.user.resendCode)

  useEffect(() => {
    if (resendCodeState.success) {
      setAlertState({
        show: true,
        variant: 'info',
        message: 'Please check your email for a validation code'
      })
    }

    if (resendCodeState.error !== false) {
      setAlertState({
        show: true,
        variant: 'danger',
        message: resendCodeState.error.message
      })
    }
  }, [resendCodeState.success, resendCodeState.error])
  
  

  const validateCode = useFormik({
    initialValues: {
      code: ''
    },
    enableReinitialize: true,
    validationSchema: ValidateCodeSchema,
    onSubmit: (values) => {
      dispatch(validateUser(user.userId, values.code))
    }
  })

  return (
    <ConfigLayout showUser={false}>
      <Container fluid id='login'>
        <Row>
          <Col xs={12} className='mb-3'>
            <Card className='auth-container mx-auto'>
              <Card.Body>
                <Form noValidate onSubmit={validateCode.handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <h3>Log In</h3>
                      <Alert
                        show={alertState.show}
                        dismissible
                        variant={alertState.variant}
                        onClose={() => setAlertState((as) => ({ ...as, show: false }))}
                      >
                        {alertState.message}
                      </Alert>
                    </Col>
                    <Form.Group as={Col} xs={12} className='mb-3'>
                      <Form.Label>Validation Code</Form.Label>
                      <Form.Control
                        id='code'
                        name='code'
                        onChange={validateCode.handleChange}
                        onBlur={validateCode.handleBlur}
                        isInvalid={!!validateCode.errors.code && validateCode.touched.code}
                        value={validateCode.values.code}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {validateCode.errors.code}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Col xs={12} className='mb-3'>
                      <Button
                        type='submit'
                        className='w-100'
                        disabled={validateUserState.loading}
                      >
                        {
                          validateUserState.loading ? <Spinner animation='border' role='status' /> : 'Validate'
                        }
                      </Button>
                    </Col>
                    <Col xs={12}>
                      Didn&apos;t receive a code? 
                      <Button onClick={() => dispatch(resendCode(user.userId))} variant='link' size='sm' className='mb-1 text-muted' disabled={resendCodeState.loading}>
                        {
                          resendCodeState.loading ? <Spinner animation='border' role='status' variant='dark' size='sm'/> : <span><u>Resend Code</u></span>
                        }
                      </Button>
                    </Col>
                    <Col xs={12}>
                      Need Help? Send email to: <u><a href='mailto:lupusadvisor@pocp.com' className='text-muted'>lupusadvisor@pocp.com</a></u>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} className='text-center mb-3'>
            <h4>
              <u><a className='text-muted' href='https://info.pocp.com/lupus_advisor' target='_blank' rel='noreferrer'>About Lupus Advisor</a></u>
            </h4>
          </Col>
          <Col xs={12} className='text-center'>
            <div className='text-muted'>
              Lupus Advisor Configurator is available to current customers of Lupus Advisor.
            </div>
          </Col>
        </Row>
      </Container>
    </ConfigLayout>
  )
}

export default Validate
